/**
 * Карта, которая сейчас на экране, — для тех, кто рисует НАД ней, но живёт вне
 * её поддерева.
 *
 * Карточки карты (отсчёт, судно, косяк, событие) рисуются страницей рядом с
 * `MapCanvas`, а не внутри него: у каждой свой запрос, своё состояние и своя
 * страница. Привязать их к географии, а не к пикселю клика, можно только имея
 * саму карту — а прокинуть её пропом значило бы протащить ссылку через восемь
 * мест вызова в двух разделах и получить восемь способов ошибиться.
 *
 * Регистр модульный, как у цветов бренда (`applyBrandMapColors`): карта в
 * кабинете ровно одна, и владеет записью тоже ровно один компонент. Снимает
 * запись только тот, кто её ставил, — при пересоздании карты (StrictMode,
 * ремоунт) уборка старой не должна стирать уже зарегистрированную новую.
 */
import type maplibregl from 'maplibre-gl'

type Listener = (map: maplibregl.Map | null) => void

let current: maplibregl.Map | null = null
const listeners = new Set<Listener>()

export function setActiveMap(map: maplibregl.Map | null): void {
  if (current === map) return
  current = map
  for (const listener of listeners) listener(map)
}

/** Снять запись, если она всё ещё своя. */
export function releaseActiveMap(map: maplibregl.Map): void {
  if (current === map) setActiveMap(null)
}

export function getActiveMap(): maplibregl.Map | null {
  return current
}

export function subscribeActiveMap(listener: Listener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
